import {
  FluidComponentDefinition,
  FluidFormElementState,
  FluidFormItem,
} from '@lmig/fluid-core';

import { Utils } from '../utils';
import { hasError } from '../validation/validation.utils';

export const isComponentDefinition = (
  element: FluidFormItem
): element is FluidComponentDefinition => {
  return 'component' in element;
};

export const valueChangeShouldEmit = (
  oldState: FluidFormElementState,
  newState: FluidFormElementState
) => {
  return Utils.isEqual(oldState, newState);
};

export function canBeCoercedToNumber(value: any): boolean {
  if (typeof value === 'number') {
    return !isNaN(value);
  }
  const coercedValue = Number(value);
  return !isNaN(coercedValue);
}

export const setInitialElementState = (
  initialValue: any,
  controlName: string
) => ({
  value: initialValue,
  errors: [],
  name: controlName,
  valid: true,
  touched: false,
});

export const elementClass = (
  elementTag: string,
  theme: string,
  elementState: FluidFormElementState,
  inlineField: boolean,
  touched: boolean,
  otherClasses?: {},
  formGroupClasses?: {}
) => ({
  componentWrapper: {
    [theme]: true,
    [elementTag]: true,
  },
  inputClass: {
    'form-control': true,
    'inline-field': inlineField,
    'has-error': hasError(elementState, touched),
    ...otherClasses,
  },
  formGroupClass: {
    'form-group': true,
    'inline-field': inlineField,
    ...formGroupClasses,
  },
});
